import type { ReactEventHandler } from 'react';
import Icon from '../Icon';
import { ICON_SIZE } from '../Icon/icon-constants';
import PaginationButton from './PaginationButton';

type PaginationControlProps = {
  icon: string;
  isDisabled?: boolean;
  onClick: ReactEventHandler;
};

//  Arrow/button for pagination control
const PaginationControl = ({ icon, isDisabled, onClick }: PaginationControlProps) => (
  <PaginationButton isDisabled={isDisabled} onClick={onClick}>
    <Icon icon={icon} size={ICON_SIZE.LG} />
  </PaginationButton>
);

export default PaginationControl;
